import React, { Component, Fragment } from 'react'

import queryString from 'query-string'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { Button, CircleLoader } from '@driftt/tide-core'

import config from 'config'
import * as OrgActions from 'modules/org/actions'
import * as OrgSelectors from 'modules/org/selectors'
import * as RoutingSelectors from 'modules/routing/selectors'

import Microsoft_Logo from './microsoft-logo.svg'

class MicrosoftAuth extends Component {
  constructor(props) {
    super(props)

    this.state = {
      loading: false,
    }
  }

  componentDidMount() {
    if (this.props.search && this.props.pathname.includes('microsoft')) {
      this.setState({ loading: true })
      this.onHideError()
      const token = queryString.parse(this.props.search).code
      this.props.onProcessingMicrosoftCode(token)
    }
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.oauthError !== this.props.oauthError &&
      this.props.oauthError !== false
    ) {
      this.setState({ loading: false })
    }
  }

  redirectToMicrosoftLogin() {
    const redirectUriPath = window.location.pathname.includes('/video')
      ? '/letsgo/video/select/microsoft'
      : '/letsgo/start/select/microsoft'

    const params = {
      response_type: 'code',
      response_mode: 'query',
      redirect_uri: `${config.LETS_GO_URL}${redirectUriPath}`,
      client_id: config.MICROSOFT_CALENDAR_CLIENT_ID,
      scope:
        'openid profile email offline_access User.Read Calendars.ReadWrite',
    }
    window.location.href = `${
      config.MICROSOFT_OAUTH_BASE_URL
    }?${queryString.stringify(params)}`
  }

  onHideError = () => {
    this.props.actions.setOAuthError(false)
  }

  render() {
    const { loading } = this.state

    return (
      <Fragment>
        <div className="touchless-start-oauth-login-container" id="microsoft">
          <Button
            className="touchless-start-oauth-login-button"
            onClick={() => !loading && this.redirectToMicrosoftLogin()}
            type="tertiary"
          >
            <div className="touchless-start-oauth-login-logo">
              <img alt="" src={Microsoft_Logo} height="20" width="20" />
            </div>
            <div className="touchless-start-oauth-login-text">
              {loading ? (
                <CircleLoader size="small" />
              ) : (
                'Sign up with Microsoft'
              )}
            </div>
          </Button>
        </div>
      </Fragment>
    )
  }
}

const mapStateToProps = (state) => ({
  pathname: RoutingSelectors.getPathname(state),
  search: RoutingSelectors.getSearch(state),
  oauthError: OrgSelectors.getOAuthError(state),
})

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      setOAuthError: OrgActions.setOAuthError,
    },
    dispatch
  ),
})

export default connect(mapStateToProps, mapDispatchToProps)(MicrosoftAuth)
